var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.866 18.159a.25.25 0 0 1 .268 0l5.029 3.195a.5.5 0 0 0 .756-.53l-1.348-6.083a.25.25 0 0 1 .076-.239l4.514-4.116a.5.5 0 0 0-.291-.868l-5.908-.536a.25.25 0 0 1-.21-.155L12.465 3.15a.5.5 0 0 0-.928 0l-2.29 5.677a.25.25 0 0 1-.21.155L3.13 9.52a.5.5 0 0 0-.292.867l4.506 4.117a.25.25 0 0 1 .076.238l-1.34 6.085a.5.5 0 0 0 .756.53l5.03-3.197Z"
  })));
};
export default SvgStar;